import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export function SuccessScreen() {
  const { t } = useTranslation()

  return (
    <Message>
      <svg width="128" height="128" viewBox="0 0 24 24">
        <rect width="24" height="24" fill="none" rx="0" ry="0" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.60138 11.5516C7.35371 11.7717 7.3314 12.1509 7.55155 12.3986L10.2182 15.3986C10.3321 15.5267 10.4953 15.6 10.6667 15.6C10.838 15.6 11.0013 15.5267 11.1151 15.3986L16.4484 9.39862C16.6686 9.15095 16.6463 8.77171 16.3986 8.55155C16.1509 8.3314 15.7717 8.35371 15.5516 8.60138L10.6667 14.0969L8.44845 11.6014C8.22829 11.3537 7.84905 11.3314 7.60138 11.5516Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.4 12C3.4 7.25035 7.25035 3.4 12 3.4C16.7497 3.4 20.6 7.25035 20.6 12C20.6 16.7497 16.7497 20.6 12 20.6C7.25035 20.6 3.4 16.7497 3.4 12ZM12 4.6C7.91309 4.6 4.6 7.91309 4.6 12C4.6 16.0869 7.91309 19.4 12 19.4C16.0869 19.4 19.4 16.0869 19.4 12C19.4 7.91309 16.0869 4.6 12 4.6Z"
          fill="currentColor"
        />
      </svg>
      <h3>{t('inquirySuccessMessage')}</h3>
    </Message>
  )
}

const Message = styled.section`
  justify-content: center;
  align-items: center;
  > svg {
    color: var(--color-primary);
  }
  max-width: 780px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 4rem;
`
